import GameScene from "../scenes/GameScene";
import { Component } from "./Component";
import { Player } from "./Player";
import { PlayerMovement } from "./PlayerMovement";

export class GroundInput extends Component {
	scene: GameScene;
	playerMovement: PlayerMovement;

	pointerDown = false;
	pointerY: number;
	swapOnRelease = true;

	inputObject: Phaser.GameObjects.Image;

	constructor(player: Player, inputObj: Phaser.GameObjects.Image) {
		super(player);
		this.scene = player.scene;
		this.playerMovement = player.getComponent(PlayerMovement);
		this.inputObject = inputObj;

		inputObj.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
		this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
	}

	destroy(): void {
		this.inputObject.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
		this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
	}

	onPointerDown(ptr: Phaser.Input.Pointer): void {
		this.pointerDown = true;
		this.pointerY = ptr.y;
		this.swapOnRelease = true;
	}

	onPointerMove(ptr: Phaser.Input.Pointer): void {
		if (this.pointerDown) {
			const dist = ptr.y - this.pointerY;
			if (dist < -50) {
				this.playerMovement.swipeUp();
				this.pointerY = ptr.y;
				this.swapOnRelease = false;
			} else if (dist > 50) {
				this.playerMovement.swipeDown();
				this.pointerY = ptr.y;
				this.swapOnRelease = false;
			}
		}
	}

	onPointerUp(): void {
		if (this.pointerDown) {
			this.pointerDown = false;
			if (this.swapOnRelease) this.playerMovement.swapLanes();
		}
	}
}
